import { API_BASE_URL } from "../../config";

export async function fetchP2PCreateLeagues(limit = 10) {
  const fixturesPerLeague = Math.min(Math.max(Number(limit), 1), 10);
  const res = await fetch(
    `${API_BASE_URL}/api/leagues?limit=${fixturesPerLeague}`
  );
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error || body?.message || "Failed to load leagues");
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function fetchP2PCreateFixturesByLeague(leagueId, page = 1, limit = 25) {
  const res = await fetch(
    `${API_BASE_URL}/api/fixtures/by-league/${leagueId}?page=${page}&limit=${limit}`
  );
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error || body?.message || "Failed to load fixtures");
  }
  const data = await res.json();
  return {
    fixtures: data?.fixtures || [],
    pagination: data?.pagination || {
      page,
      limit,
      hasNextPage: false,
    },
  };
}
